import {
  CommonIncidentId,
  EventStatusId,
  IncidentId,
} from '@collector/sportsapi-client-legacy'

import { PossibleIncidentsCombinations } from '../configuration'
import { injectSameTimeIncidentsConfig } from '../provide-inject'

export function useSameTimeIncidents(): {
  sameTimeExcludedIncidents: Set<IncidentId>
  sameTimeExcludedIncidentEventStatuses: Set<EventStatusId>
  sameTimePossibleIncidentsCombinations: PossibleIncidentsCombinations
} {
  const sameTimeIncidentsConfig = injectSameTimeIncidentsConfig()

  const sameTimeExcludedIncidents = new Set<IncidentId>([
    CommonIncidentId.Betstart,
    CommonIncidentId.Betstop,
    ...(sameTimeIncidentsConfig?.excludedIncidents || []),
  ])

  const sameTimeExcludedIncidentEventStatuses = new Set<EventStatusId>([
    ...(sameTimeIncidentsConfig?.excludedIncidentEventStatuses || []),
  ])

  const sameTimePossibleIncidentsCombinations = [
    ...(sameTimeIncidentsConfig?.possibleIncidentsCombinations || []),
  ]

  return {
    sameTimeExcludedIncidents,
    sameTimeExcludedIncidentEventStatuses,
    sameTimePossibleIncidentsCombinations,
  }
}
